export default defineNuxtPlugin(() => {
  const { public: publicConfig } = useRuntimeConfig()
  const version = String(publicConfig.appVersion || 'dev')

  console.info(`[terminal] version: ${version}`)
})
